<template>
    <el-button class="x-button x-button-submit"
               :disabled="disabled"
               @click="$emit('click')"
               v-loading="loading">{{ text }}
    </el-button>
</template>

<script>

export default {
    name: 'XButtonSubmit',
    props: {
        text: {
            type: String,
            default: 'Aceptar'
        },
        loading: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {}
    },
}
</script>
